<script setup>
import { computed, inject } from 'vue';
import { themeColor } from '../canvasStyles';

const props = defineProps({ element: { type: Object, required: true } });
defineOptions({ inheritAttrs: false });

const ed = inject('emailEditor');
const st = computed(() => props.element.style || {});
const line = computed(() => ({
  borderTop: `${st.value.thickness}px ${st.value.line_style} ${
    themeColor(st.value.color, ed.template.value?.theme || {}) || '#e6e9ee'
  }`,
  width: `${st.value.width}%`,
}));
</script>

<template>
  <div class="py-1"><div class="mx-auto" :style="line" /></div>
</template>
